module.exports = __webpack_public_path__ + "static/media/fiber.bf9ec8c3.svg";